import React, {useEffect, useState} from 'react';
import ElevenLabsIntegration from './pages/ElevenLabsIntegration';
import { BrowserRouter as Router, Route, Routes, Link, useParams } from 'react-router-dom';
import './App.css';
import axios from 'axios';

function Home() {
  const [voiceBots, setVoiceBots] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchVoiceBots = async () => {
    try {
        //const response = await axios.get('https://otacon.it/wp-json/voicebot/v1/list');
        const response = await axios.get('https://salespark.it/wp-json/voicebot/v1/list');
        console.log(response.data);
        setVoiceBots(response.data); // Salva i dati nello stato
        setIsLoading(false);
    } catch (err) {
        console.log(err);
    }
  };

  useEffect(() => {
      fetchVoiceBots();
  }, []);

  return (
    <div className="home-container">
      <h1>Conversational AI Demo</h1>
      <div className="box-container">
        {isLoading ? (
          <p>Loading...</p>
        ) : (
          voiceBots?.map((agent) => (
            <Link to={`/agent/${agent.id11labs}`} key={agent.id11labs} className="box">
              {agent.nome}
            </Link>
          ))
        )}
      </div>
    </div>
  );
}

function AgentPage() {
  const { agentId } = useParams();
  return (
    <ElevenLabsIntegration agentId={agentId} apiKey="sk_d4dca58bc057f1d057ab38c9b011601825fedb8038f3dba3" />
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/agent/:agentId" element={<AgentPage />} />
      </Routes>
    </Router>
  );
}

export default App;
